import React, { useState } from "react";
import {
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  Menu,
  MenuItem,
  Button,
} from "@mui/material";
import {
  CopyAll,
  Email,
  SupportAgent,
  KeyboardArrowDown,
} from "@mui/icons-material";
import { toast } from "react-toastify";

export const Session = ({
  handleSessionSelection,
  selectedSession,
  sessions,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (session) => {
    handleSessionSelection(session);
    handleClose();
  };

  return (
    <>
      <Button
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
        }}
        endIcon={<KeyboardArrowDown />}
        sx={{
          backgroundColor: "#ffffff",
          border: "1px solid #b6c8d6",
          borderRadius: "8px",
          color: "#084c84",
          textTransform: "none",
          fontSize: isMobile ? "0.875rem" : "1rem",
          fontWeight: 400,
          padding: isMobile ? "3px 6px" : "8px",
          "&:hover": {
            backgroundColor: "#f5f5f5",
            border: "1px solid #084c84",
          },
        }}
      >
        {selectedSession}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          mt: 1,
        }}
      >
        {sessions?.map((session) => (
          <MenuItem
            key={session}
            onClick={() => handleMenuItemClick(session)}
            selected={session === selectedSession}
            sx={{
              color: "#084c84",
              fontSize: isMobile ? "0.875rem" : "1rem",
              "&.Mui-selected": {
                backgroundColor: "#e3f2fd",
                "&:hover": {
                  backgroundColor: "#bbdefb",
                },
              },
            }}
          >
            {session}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export const SupportContainer = () => {
  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        gap={0.5}
        sx={{
          border: "1px solid #b6c8d6",
          borderRadius: "8px",
          px: 0.75,
        }}
      >
        <SupportAgent
          sx={{
            color: "#084c84",
            fontSize: "2.5rem",
            cursor: "pointer",
          }}
          onClick={() =>
            window.open("/help-and-support", "_blank", "noopener,noreferrer")
          }
        />
        <Stack direction={"row"} gap={1} alignItems={"center"}>
          <Stack direction={"column"}>
            <Typography
              sx={{
                color: "#084c84",
                p: 0,
              }}
            >
              08069328986{" "}
            </Typography>
            <Typography
              sx={{
                color: "green",
                p: 0,
              }}
            >
              support@ekalsutra.com{" "}
            </Typography>
          </Stack>
          {/* icons */}
          <Stack direction={"column"} gap={0.25}>
            <IconButton
              sx={{
                color: "#084c84",
                p: 0,
                alignItems: "center",
              }}
              onClick={() => {
                navigator.clipboard.writeText("08069328986");
                toast.success("Copied to clipboard");
              }}
            >
              <CopyAll fontSize="small" />
            </IconButton>
            <IconButton
              sx={{
                color: "#084c84",
                p: 0,
                alignItems: "center",
              }}
              onClick={() => {
                navigator.clipboard.writeText("support@ekalsutra.com");
                toast.success("Copied to clipboard");
              }}
            >
              <Email fontSize="small" />
            </IconButton>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
